import { Button } from '@/components/ui/button';
import { useAuth } from '@pooflabs/web';
import { Search, ShieldCheck, Store } from 'lucide-react';
import React from 'react';
import { toast } from 'sonner';

export const HeroSection: React.FC = () => {
  const { login } = useAuth();

  const handleAuth = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Failed to login', error);
      toast.error('Could not open wallet login. Please try again.');
    }
  };

  return (
    <section className='relative overflow-hidden'>
      {/* Soft coral glow, top-right — subtle atmosphere without heavy shadows */}
      <div className='pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-primary/10 blur-3xl' />
      <div className='pointer-events-none absolute -left-32 top-40 h-72 w-72 rounded-full bg-accent/10 blur-3xl' />

      <div className='container relative z-10 py-20 sm:py-28'>
        <div className='mx-auto max-w-3xl text-center'>
          <span className='inline-flex items-center gap-1.5 rounded-full bg-secondary px-3 py-1 text-xs font-bold uppercase tracking-widest text-primary'>
            <ShieldCheck className='h-3.5 w-3.5' />
            Built for FUTO
          </span>

          <h1 className='font-heading mt-6 text-4xl font-bold leading-[1.05] tracking-tight text-foreground sm:text-5xl md:text-6xl'>
            Buy from vendors you can actually trust.
          </h1>

          <p className='mx-auto mt-6 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg'>
            Creve connects FUTO students directly with FUTO vendors — and
            every single vendor is identity-verified with NIN and school ID
            before they're allowed to sell a thing.
          </p>

          <div className='mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row'>
            <Button
              size='lg'
              onClick={handleAuth}
              className='w-full gap-2 rounded-full bg-primary px-7 text-base text-primary-foreground hover:bg-primary/90 sm:w-auto'
            >
              <Search className='h-4 w-4' />
              Start browsing
            </Button>
            <Button
              size='lg'
              variant='outline'
              onClick={handleAuth}
              className='w-full gap-2 rounded-full border-2 border-foreground/15 bg-transparent px-7 text-base text-foreground hover:bg-secondary hover:text-primary sm:w-auto'
            >
              <Store className='h-4 w-4' />
              Sell on Creve
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
